import { SvgIcon, SvgIconProps } from "@mui/material";

export const WindowResizeLeftIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M14 3v18M9.5 10l-2 2 2 2"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M11 21H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h3M14 21h2a5 5 0 0 0 5-5V8a5 5 0 0 0-5-5h-2"
      />
    </svg>
  </SvgIcon>
);
